

import React from 'react';
import GrammarPageLayout from '../components/grammar-page-layout';
import GrammarExplanation from '../components/explanations/some-any-explanation';

const mainimage = '/Images/obligation1.webp';

const sections = [
 
  { label: "Exercises", description: "Do this exercise to practice grammar.", type: "quiz", subtype: "someany" },
];

const Someany = () => (
  <GrammarPageLayout
    level="A1"
    title="Some, any"
    image={mainimage}
    ExplanationComponent={GrammarExplanation}
    sections={sections}
    seoTitle="Free English Some and Any Exercises"
    seoDescription="Practice Some, any with interactive exercises for A1 level English exams."
    relatedCategory="grammar-exercises"
    relatedLevel="A1"
  />
);

export default Someany;

